var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "trash_svg__a",
    d: "M0 0h25.281v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "trash_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#trash_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.573 25.947a2.708 2.708 0 01-2.696 2.705H6.404a2.707 2.707 0 01-2.696-2.705V4.719h17.865v21.228zM8.764 3.367c0-1.191 1.053-2.019 2.244-2.019h3.686c1.19 0 2.16.828 2.16 2.018v.005h-8.09v-.005zm15.843.004h-2.265c-.031-.005-.062-.01-.095-.01-.032 0-.063.005-.095.01h-3.95v-.005C18.202 1.432 16.63 0 14.694 0h-3.686C9.073 0 7.416 1.432 7.416 3.366v.005H3.128a.576.576 0 00-.094-.01.588.588 0 00-.095.01H.674a.674.674 0 000 1.348H2.36v21.228A4.056 4.056 0 006.404 30h12.473a4.056 4.056 0 004.044-4.053V4.719h1.686a.674.674 0 000-1.348z",
    mask: "url(#trash_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.09 24.944a.674.674 0 00.674-.674V9.1a.674.674 0 00-1.348 0v15.17c0 .372.302.674.674.674m4.719 0a.674.674 0 00.674-.674V9.1a.674.674 0 00-1.348 0v15.17c0 .372.302.674.674.674m4.719 0a.674.674 0 00.674-.674V9.1a.674.674 0 00-1.348 0v15.17c0 .372.302.674.674.674"
  }))));
};

export default SvgTrash;